import { Redirect, Slot, Stack, usePathname } from "expo-router";
import { StatusBar } from "expo-status-bar";

import { ResponsiveRenderer } from "~/components/ResponsiveRenderer";
import { isWeb } from "~/lib/constants";
import { useSessionContext } from "~/lib/supabase";

export default function AppGroupLayout() {
  const { session, isLoading } = useSessionContext();
  const pathname = usePathname();
  if (isLoading) return null;

  if (!session && !pathname.startsWith("/auth")) {
    let params = "";
    if (typeof window !== "undefined") {
      params = window.location.search;
    }
    return <Redirect href={`/(app)/auth/login${params}`} />;
  }

  return (
    <>
      <StatusBar />
      <ResponsiveRenderer
        webDesktop={<Slot />}
        default={
          <Stack
            screenOptions={{
              headerBackButtonMenuEnabled: false,
              headerShadowVisible: !isWeb,
            }}
          >
            <Stack.Screen
              name="(authenticated)"
              options={{ headerShown: false, animation: "fade" }}
            />
            <Stack.Screen name="auth" options={{ headerShown: false }} />
          </Stack>
        }
      />
    </>
  );
}
